var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAccountConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#EFE8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#EFE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8568 6.98838C19.6143 6.86812 19.3747 6.89474 19.2127 6.9369C19.0515 6.97888 18.895 7.05468 18.7557 7.13208C18.4833 7.28334 18.1354 7.52249 17.7225 7.80626L8.66314 14.032C8.39833 14.2139 8.15603 14.3804 7.98342 14.5307C7.82619 14.6676 7.55479 14.9308 7.54894 15.3306C7.5465 15.497 7.58397 15.6616 7.65821 15.8105C7.83655 16.1683 8.19515 16.2881 8.39616 16.3434C8.61682 16.4042 8.90729 16.4494 9.22476 16.4987L12.2178 16.9644L10.224 20.4856C9.98678 20.9046 9.78557 21.2599 9.66271 21.5364C9.59965 21.6784 9.53923 21.8381 9.51246 22.0007C9.48534 22.1656 9.48216 22.4005 9.61767 22.627C9.71224 22.785 9.847 22.9151 10.0082 23.0041C10.2393 23.1315 10.474 23.1201 10.6378 23.0872C10.7994 23.0548 10.9569 22.9888 11.0965 22.9208C11.3686 22.7883 11.7166 22.5748 12.1269 22.323L21.2913 16.7005C21.5567 16.5377 21.8011 16.3878 21.9774 16.2494C22.1404 16.1214 22.4172 15.8771 22.447 15.4855C22.4594 15.3212 22.4328 15.1563 22.3691 15.0043C22.2174 14.642 21.8777 14.4974 21.6827 14.4274C21.4718 14.3516 21.1926 14.2864 20.8894 14.2156L17.6617 13.4612L19.7061 9.5676C19.939 9.12403 20.1353 8.7502 20.2533 8.46187C20.3137 8.31432 20.3704 8.14997 20.393 7.98493C20.4158 7.81917 20.4138 7.57805 20.2657 7.35152C20.1642 7.19621 20.023 7.07084 19.8568 6.98838Z",
    fill: "#7F43FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccountConnection);
export default __webpack_public_path__ + "static/media/bank-account-connection.7a136c63e07b6c997262838b3a98aaed.svg";
export { ForwardRef as ReactComponent };